import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTime',
  standalone: true,
})
export class SecondsToTimePipe implements PipeTransform {
  transform(seconds: number): string {
    if (!seconds || seconds <= 0) return '0s';

    if (seconds < 60) {
      return `${seconds}s`;
    }

    const hours = Math.floor(seconds / 3600);
    const minutes = (seconds % 3600) / 60;

    if (hours >= 1) {
      return `${hours}h ${minutes.toFixed(1)}m`;
    } else {
      return `${minutes.toFixed(1)}m`;
    }
  }
}